import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../lib/api";
import AnimatedImage from "../../components/AnimatedImage";
import { ArrowLeft } from "lucide-react";

export default function NewsDetail() {
    const { slug } = useParams();
    const [story, setStory] = useState(null);
    const [notFound, setNotFound] = useState(false);
    useEffect(() => {
        setStory(null); setNotFound(false);
        api.get(`/news/${slug}`).then(({ data }) => setStory(data)).catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) return <div className="py-32 text-center"><h1 className="font-display text-3xl mb-4">Story not found</h1><Link to="/news" className="text-primary underline">Back to news</Link></div>;
    if (!story) return <div className="py-32 text-center text-muted-foreground">Loading…</div>;

    return (
        <article className="max-w-4xl mx-auto px-6 lg:px-10 py-20" data-testid="news-detail">
            <Link to="/news" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary mb-8">
                <ArrowLeft size={14} /> All Stories
            </Link>
            <div className="text-xs uppercase tracking-[0.18em] text-primary mb-4">{story.category}</div>
            <h1 className="font-display text-4xl sm:text-5xl leading-tight mb-6">{story.title}</h1>
            <div className="text-sm text-muted-foreground mb-10">By {story.author}</div>
            <div className="aspect-[16/9] mb-10 rounded-sm overflow-hidden">
                <AnimatedImage src={story.image_url} alt={story.title} className="w-full h-full" />
            </div>
            <div className="prose-y text-lg leading-relaxed text-foreground/90 whitespace-pre-line">{story.body}</div>
        </article>
    );
}
